<ion-header class="ion-no-border">
  <ion-toolbar class="modal-toolbar">
    <ion-title>Reservas em lote</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Fechar">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="modal-context">
    Crie várias reservas com a mesma configuração (ex: turma toda terça, 19h–20h).
  </div>
</ion-header>

<ion-content class="modal-content">
  <lessor-multi-rents></lessor-multi-rents>
</ion-content>
